export type SortKey = 'name' | 'orderingEnabled' | 'locationStatus'
export type SortDirection = 'asc' | 'desc'
export type SortState = { key: SortKey; direction: SortDirection } | null

export const PAGE_SIZE_OPTIONS = [10, 25, 50, 100] as const
export type PageSize = typeof PAGE_SIZE_OPTIONS[number]
export const DEFAULT_PAGE_SIZE: PageSize = 25
